import { call, put, takeEvery } from 'redux-saga/effects';
import request from '../../utils/request';
import errorMessages from '../../components/Error/messages';
import {
  API_URL_CAMPAIGN_LIST,
  API_URL_WEBMASTER_GET_REFERRAL_LINK,
} from '../../config';
import * as constants from './constants';
import { getAuthToken } from '../../containers/Auth/token';
import {
  getCampaignSuccess,
  getCampaignError,
  getReferralLinkSuccess,
  getReferralLinkError,
} from './actions';

function getCampaignRequest(token) {
  const data = JSON.stringify({
    token,
    connected: '1',
  });
  const url = `${API_URL_CAMPAIGN_LIST}?data=${data}`;
  const options = {
    method: 'GET',
  };

  return request(url, options);
}

function getReferralLinkRequest(token, campaignId) {
  const data = JSON.stringify({
    token,
    campaign_id: campaignId,
  });
  const url = `${API_URL_WEBMASTER_GET_REFERRAL_LINK}?data=${data}`;
  const options = {
    method: 'GET',
  };

  return request(url, options);
}

function* getCampaignFlow() {
  try {
    const token = yield getAuthToken();
    const campaignRequest = yield call(getCampaignRequest, token);
    const { response: campaignResponse } = campaignRequest;
    if (campaignResponse.success === 1 && campaignResponse.data.length) {
      const campaign = campaignResponse.data[0];
      yield put(getCampaignSuccess(campaign));

      const linkRequest = yield call(
        getReferralLinkRequest,
        token,
        campaign.campaign_id,
      );
      const { response: linkResponse } = linkRequest;
      if (linkResponse.success === 1) {
        yield put(getReferralLinkSuccess(linkResponse.data.referral_link));
      } else {
        yield put(getReferralLinkError());
      }
      return;
    }
    throw errorMessages.defaultMessage;
  } catch (error) {
    yield put(getCampaignError(error));
  }
}

// run in parallel
export default function* rootSaga() {
  yield takeEvery(constants.GET_CAMPAIGN_REQUEST, getCampaignFlow);
}



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/sagas.js